/* 4Women — Cinta 16:9: el video se descarga y arranca cuando se ve, no antes.
 *
 * Acompaña a `sections/fw-cinta.liquid`, donde esta el POR QUE del bloque
 * entero. Aqui solo el comportamiento.
 *
 * ============================================================
 * POR QUE NO SE USA EL AUTOPLAY DEL NAVEGADOR
 * ============================================================
 *
 * Porque `autoplay` pide el archivo apenas se pinta la pagina, este la cinta a
 * la vista o tres pantallas mas abajo. Un banner en .mov pesa varios megas y
 * esta tienda se abre desde Instagram con datos moviles: descargarlo para
 * alguien que nunca baja hasta ahi es gastarle el dato a la clienta y competir
 * con las fotos de producto, que si se ven.
 *
 * Asi que el video sale del servidor con `preload="none"` y sin autoplay, y lo
 * arranca un IntersectionObserver cuando la cinta entra en pantalla. Fuera de
 * pantalla se pausa: un video corriendo detras del pliegue es bateria quemada.
 *
 * ============================================================
 * EL POSTER MANDA HASTA QUE HAY FOTOGRAMAS
 * ============================================================
 *
 * El video se pinta encima de la foto pero transparente, y solo se enciende
 * cuando tiene imagen de verdad —evento `loadeddata`, no `play`—. Con `play` se
 * enciende un elemento que todavia no decodifico nada y se ve un parpadeo negro
 * entre el poster y el primer fotograma.
 *
 * ============================================================
 * QUIEN PIDIO MENOS MOVIMIENTO NO VE VIDEO
 * ============================================================
 *
 * `prefers-reduced-motion` no es una preferencia estetica: hay gente a la que el
 * movimiento en bucle le produce mareo. Se queda el poster, que es una foto
 * perfectamente buena. El CSS ademas esconde el elemento; esto evita ademas la
 * descarga.
 *
 * ============================================================
 * DELEGADO Y REPETIBLE
 * ============================================================
 *
 * El editor de temas repinta la seccion por innerHTML, asi que se vuelve a
 * enganchar con `shopify:section:load`. Cada video se marca para no observarlo
 * dos veces.
 */
(() => {
  if (window.__fwCinta) return;
  window.__fwCinta = true;

  const quieto =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Un solo observador para todas las cintas de la pagina. Con `rootMargin` de
     200px el video empieza a pedirse un pelo antes de asomar, asi que cuando la
     clienta llega ya hay fotogramas en vez de un poster que salta. */
  const ojo =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entradas) => {
            entradas.forEach((e) => {
              const v = e.target;
              if (e.isIntersecting) {
                /* `preload="none"` significa que el navegador no bajo NADA, ni
                   siquiera la cabecera. `load()` le dice que empiece; sin esto,
                   `play()` sobre un elemento sin fuentes cargadas tarda mas o
                   directamente no arranca en algunos navegadores. */
                if (v.preload === 'none') {
                  v.preload = 'auto';
                  try {
                    v.load();
                  } catch (err) {
                    /* Un video roto no puede tumbar la pagina. */
                  }
                }
                const p = v.play();
                /* `play()` devuelve una promesa que se rechaza si el navegador
                   decide que no corresponde reproducir. Sin el catch, eso sale
                   por consola como un error no capturado en cada scroll. */
                if (p && typeof p.catch === 'function') p.catch(() => {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.01 }
        )
      : null;

  const enganchar = () => {
    document.querySelectorAll('[data-fw-cinta-vid]').forEach((v) => {
      if (v.__fwListo) return;
      v.__fwListo = true;

      if (quieto) {
        /* Ni se observa ni se pide el archivo: queda el poster. */
        v.removeAttribute('data-fw-cinta-vid');
        return;
      }

      /* Se enciende con `loadeddata` —ya hay un fotograma decodificado— y no con
         `play`, para que no haya un negro entre el poster y la imagen. */
      const encender = () => v.classList.add('is-lista');
      if (v.readyState >= 2) encender();
      else v.addEventListener('loadeddata', encender, { once: true });

      /* Si el archivo no se puede reproducir, el poster se queda y no pasa nada
         mas. Sin esto quedaria una caja transparente sobre la foto, que se ve
         igual pero deja el elemento intentando para siempre. */
      v.addEventListener(
        'error',
        () => {
          v.classList.remove('is-lista');
          if (ojo) ojo.unobserve(v);
        },
        { once: true }
      );

      if (ojo) ojo.observe(v);
      else {
        /* Navegador sin IntersectionObserver: se reproduce y listo. Es peor para
           el dato, pero es mejor que una cinta muerta. */
        v.preload = 'auto';
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }

  document.addEventListener('shopify:section:load', enganchar);
})();
